import axiosInst from "@/utility/axiosInst";

export default {
  requestCreateFuneralInvitation({}, payload) {
    return axiosInst.springAxiosInst.post("/funeral/create-funeral", payload).then(res => {
      return res.data;
    });
  },

  requestFuneralInvitationForEdit({}, funeralInvitationSeq) {
    return axiosInst.springAxiosInst.get("/funeral/get-funeral-for-edit", {
      params: {
        funeralInvitationSeq: funeralInvitationSeq
      }
    }).then((res) => {
      return res.data
    })
  },

  requestFuneralInvitationEdit({}, payload){
    return axiosInst.springAxiosInst.post('/funeral/edit-funeral', payload).then(res => {
      return res.data
    })
  } 
};